import { render, staticRenderFns } from "./swipe-group.vue?vue&type=template&id=e9decd8c&scoped=true&"
import script from "./swipe-group.vue?vue&type=script&lang=js&"
export * from "./swipe-group.vue?vue&type=script&lang=js&"
import style0 from "./swipe-group.vue?vue&type=style&index=0&id=e9decd8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9decd8c",
  null
  
)

export default component.exports